import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { auth } from '../services/firebase'
import { getAllMovieRequests, deleteMovieRequest } from '../services/movieRequests'
import Loader from '../components/common/Loader'
import './AdminRequests.css'

// Admin UID - only this user can access this page
const ADMIN_UID = 'bdvqas1HoJP7Q4gop9mHqyvNtbu2'

function AdminRequests() {
  const navigate = useNavigate()
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(true)
  const [deleting, setDeleting] = useState(null)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    // Check if user is admin
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user || user.uid !== ADMIN_UID) {
        navigate('/')
        return
      }
      setIsAdmin(true)
      loadRequests()
    })
    
    return () => unsubscribe()
  }, [navigate])

  const loadRequests = async () => {
    setLoading(true)
    const allRequests = await getAllMovieRequests()
    // Sort by date (newest first)
    allRequests.sort((a, b) => {
      const aTime = a.requestedAt?.seconds || 0
      const bTime = b.requestedAt?.seconds || 0
      return bTime - aTime
    })
    setRequests(allRequests)
    setLoading(false)
  }

  const handleDelete = async (request) => {
    if (!confirm(`¿Eliminar solicitud de "${request.title}"?`)) return
    
    setDeleting(request.id)
    const success = await deleteMovieRequest(request.id)
    if (success) {
      setRequests(prev => prev.filter(r => r.id !== request.id))
    }
    setDeleting(null)
  }

  const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return 'Fecha desconocida'
    return new Date(timestamp.seconds * 1000).toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    })
  }

  if (!isAdmin) {
    return <Loader />
  }

  return (
    <div className="admin-requests-page container">
      <div className="admin-header">
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          ← Volver
        </button>
        <h1>📋 Solicitudes de Películas</h1>
        <span className="request-count">{requests.length} solicitudes</span>
      </div>

      {loading ? (
        <Loader />
      ) : requests.length === 0 ? (
        <div className="no-requests">
          <p>🎉 No hay solicitudes pendientes</p>
        </div>
      ) : (
        <div className="requests-grid">
          {requests.map(request => (
            <div key={request.id} className="request-card">
              <div className="request-poster">
                {request.poster ? (
                  <img src={request.poster} alt={request.title} />
                ) : (
                  <div className="no-poster">🎬</div>
                )}
              </div>
              <div className="request-info">
                <h3 className="request-title">{request.title}</h3>
                {request.year && <span className="request-year">{request.year}</span>}
                <p className="request-meta">
                  <span className="request-by">👤 {request.requestedByName}</span>
                  <span className="request-date">📅 {formatDate(request.requestedAt)}</span>
                </p>
                <a 
                  href={`https://www.imdb.com/title/${request.imdbId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="imdb-link"
                >
                  Ver en IMDB →
                </a>
              </div>
              <button
                className="btn btn-delete"
                onClick={() => handleDelete(request)}
                disabled={deleting === request.id}
              >
                {deleting === request.id ? '...' : '🗑️'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default AdminRequests
